/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import pt from 'prop-types';
import { Field } from 'components/form';
import Icon from 'components/icon';
import { DropdownMenu } from 'components/dropdown-menu';
import { postEasyblocksCanvasPageRoute } from 'components/storefront/editor/utils/post-message';
import StorefrontEditorPageList from './page-list';
import StorefrontEditorPageGroup from './page-group';

const CONTENT_OFFSET = 6;
const NO_RECORDS_MESSAGE = 'No pages found';

export default class StorefrontEditorPageDropdown extends React.PureComponent {
  static propTypes = {
    pages: pt.shape({ templates: pt.array, pages: pt.array }),
    page: pt.object,
    onClickAddPage: pt.func,
    loading: pt.bool,
  };

  state = {
    open: false,
    search: null,
    pageGroup: null,
  };

  onOpenChange = (open) => {
    this.setState({ open });
  };

  onSearchChange = (event, value) => {
    event.preventDefault();

    this.setState({ search: value.trim().toLocaleLowerCase() });
  };

  onClickPage = (pageId) => {
    if (!pageId) {
      return;
    }

    postEasyblocksCanvasPageRoute(pageId);

    this.setState({ open: false });
  };

  onClickAddPage = () => {
    const { onClickAddPage } = this.props;

    onClickAddPage?.();
    this.setState({ open: false });
  };

  onClickPageGroup = (pageId) => {
    if (!pageId) {
      this.setState({ pageGroup: null });
    }

    const { pages } = this.props;
    const pageGroup = pages.templates.find(
      (page) => Boolean(page.items) && page.id === pageId,
    );

    this.setState({ pageGroup });
  };

  onClickBackPageGroup = () => {
    this.onClickPageGroup(null);
  };

  isPageMatch = (page) => {
    const { search } = this.state;

    return page.label.toLocaleLowerCase().includes(search);
  };

  filter(pages) {
    const { search } = this.state;
    const hasPages = pages?.length > 0;

    if (!search || !hasPages) {
      return pages;
    }

    return pages.filter((page) => {
      if (this.isPageMatch(page)) {
        return true;
      }

      if (page.items?.some(this.isPageMatch)) {
        return true;
      }

      return false;
    });
  }

  getLists() {
    const { templates, pages } = this.props.pages;

    return { templates: this.filter(templates), pages: this.filter(pages) };
  }

  getPageGroup() {
    const { pageGroup } = this.state;

    return { ...pageGroup, items: this.filter(pageGroup.items) };
  }

  renderSearch() {
    return (
      <div className="storefront-editor--page-dropdown--search">
        <Field
          type="text"
          placeholder="Search"
          onChange={this.onSearchChange}
        />
        <Icon fa="search" faType="solid" />
      </div>
    );
  }

  renderPageLists() {
    const { page, loading } = this.props;
    const { templates, pages } = this.getLists();
    const hasTemplates = templates?.length > 0;
    const hasPages = pages?.length > 0;

    return (
      <>
        {hasTemplates && (
          <StorefrontEditorPageList
            label="Templates"
            pages={templates}
            selectedPage={page}
            onClickPage={this.onClickPage}
            onClickPageGroup={this.onClickPageGroup}
          />
        )}
        {hasPages && (
          <StorefrontEditorPageList
            label="Pages"
            pages={pages}
            selectedPage={page}
            onClickPage={this.onClickPage}
            onClickAddPage={this.onClickAddPage}
            allowAdding
          />
        )}
        {!loading && !hasTemplates && !hasPages && (
          <div className="storefront-editor--no-records">
            {NO_RECORDS_MESSAGE}
          </div>
        )}
      </>
    );
  }

  renderPageGroup() {
    const { page } = this.props;

    return (
      <StorefrontEditorPageGroup
        pageGroup={this.getPageGroup()}
        selectedPage={page}
        onClickPage={this.onClickPage}
        onClickBack={this.onClickBackPageGroup}
        noRecordsMessage={NO_RECORDS_MESSAGE}
      />
    );
  }

  renderPages() {
    return this.state.pageGroup
      ? this.renderPageGroup()
      : this.renderPageLists();
  }

  renderTrigger() {
    const { page } = this.props;
    const { open } = this.state;

    return (
      <>
        {page.label}
        <Icon fa={open ? 'chevron-up' : 'chevron-down'} />
      </>
    );
  }

  render() {
    const { loading } = this.props;
    const { open } = this.state;

    return (
      <div className="storefront-editor--page-dropdown">
        <DropdownMenu
          contentClassName="dropdown-menu-content storefront-editor--page-dropdown--content"
          triggerClassName="button button-secondary storefront-editor--page-dropdown--trigger"
          triggerChildren={this.renderTrigger()}
          rootRest={{ open, onOpenChange: this.onOpenChange }}
          contentRest={{
            sideOffset: CONTENT_OFFSET,
          }}
          disabled={loading}
        >
          {this.renderSearch()}
          {this.renderPages()}
        </DropdownMenu>
      </div>
    );
  }
}
